import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import styles from './LanguageToggle.module.css';

const LanguageToggle = () => {
  const { language, toggleLanguage, setLanguage } = useLanguage();

  return (
    <div className={styles.toggleWrapper} title="Switch Language / تغيير اللغة">
      <button 
        type="button" 
        className={`${styles.langBtn} ${language === 'en' ? styles.active : ''}`}
        onClick={() => setLanguage('en')}
        aria-label="Switch to English"
      >
        <span className={styles.flagIcon}>🇺🇸</span>
        <span className={styles.langText}>EN</span>
      </button>
      <button 
        type="button" 
        className={`${styles.langBtn} ${language === 'ar' ? styles.active : ''}`}
        onClick={() => setLanguage('ar')}
        aria-label="التحويل إلى العربية"
      >
        <span className={styles.flagIcon}>🇸🇦</span>
        <span className={styles.langText}>عربي</span>
      </button>
    </div>
  );
};

export default LanguageToggle;
